import { useMemo } from 'react';

const useComponentWillMount = callback => {
  useMemo(callback, []);
};

export default useComponentWillMount;
